﻿{
  "version": 1,
  "gameId": "chess",
  "economy": { "offlineEntryCoins": 0, "offlineWinCoins": 0, "offlineWinXp": 20, "offlineLossXp": 0, "onlineEntryCoins": 0, "onlineWinCoins": 0, "onlineWinXp": 0, "onlineLossXp": 0, "hintCoins": 200 },
  "tutorial": {
    "view": "rules",
    "navigationLabelKey": "chess.rules.navigationLabel",
    "kickerKey": "chess.rules.kicker",
    "titleKey": "chess.rules.title",
    "summaryKey": "chess.rules.summary",
    "sections": [
      { "id": "setup", "key": "chess.rules.setup" },
      { "id": "moves", "key": "chess.rules.moves" },
      { "id": "check", "key": "chess.rules.check" },
      { "id": "special", "key": "chess.rules.special" },
      { "id": "promotion", "key": "chess.rules.promotion" },
      { "id": "finish", "key": "chess.rules.finish" },
      { "id": "modes", "key": "chess.rules.modes" }
    ],
    "settingsAccess": false
  },
  "cosmetics": {
    "boardThemes": [
      { "id": "classic", "nameKey": "chess.theme.walnut", "price": 0, "image": "/assets/boards/chess/chess-board-walnut.jpg" },
      { "id": "desert", "nameKey": "chess.theme.desert", "price": 160, "image": "/assets/boards/chess/chess-board-desert.jpg" },
      { "id": "parchment", "nameKey": "chess.theme.parchment", "price": 150, "image": "/assets/boards/chess/chess-board-parchment.jpg" },
      { "id": "stone", "nameKey": "chess.theme.stone", "price": 190, "image": "/assets/boards/chess/chess-board-stone.jpg" },
      { "id": "neon", "nameKey": "chess.theme.neon", "price": 260, "image": "/assets/boards/chess/chess-board-neon.jpg" },
      { "id": "sketch", "nameKey": "chess.theme.sketch", "price": 110, "image": "/assets/boards/chess/chess-board-sketch.jpg" },
      { "id": "navy-tile", "nameKey": "chess.theme.navyTile", "price": 210, "image": "/assets/boards/chess/chess-board-navy-tile.jpg" },
      { "id": "ceramic", "nameKey": "chess.theme.ceramic", "price": 240, "image": "/assets/boards/chess/chess-board-ceramic.jpg" },
      { "id": "steel", "nameKey": "chess.theme.steel", "price": 280, "image": "/assets/boards/chess/chess-board-steel.jpg" },
      { "id": "brick", "nameKey": "chess.theme.brick", "price": 230, "image": "/assets/boards/chess/chess-board-brick.jpg" }
    ]
  }
}
